var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FilePreview d-flex flex-grow-1 align-items-center justify-content-center"},[_vm._v(" "+_vm._s(_vm.$t('Loading file preview...'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }